import { lazy } from 'react';

export const CourseDetailPage = lazy(() => import('./CourseDetailPage'));
